import { render, staticRenderFns } from "./oss-img.vue?vue&type=template&id=501b98b1&"
import script from "./oss-img.vue?vue&type=script&lang=js&"
export * from "./oss-img.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports